import { isHeicFile, convertHeicToJpeg } from "common/utils/heic-converter";

export const isBlobUrl = url => {
  try {
    return new URL(url).protocol === "blob:";
  } catch (error) {
    return false;
  }
};

export const fileToBlob = async file => {
  if (isHeicFile(file)) {
    return convertHeicToJpeg(file);
  }
  return file;
};

export default {};
